export type ExperienceVariant = "meta" | "etsy";

export type PageVariant = {
  id: ExperienceVariant;
  path: "/" | "/etsy";
  documentTitle: string;
  phase: string;
  heroEyebrow?: string;
  heroLineOne: string;
  heroLineTwo: string;
  heroSupporting?: string;
  requestInput: string;
  loadingCta: string;
  motionEyebrow: string;
  motionHeadline: string;
  emptyState: string;
  previewTitle: string;
  draftError: string;
  footer: string;
};

const DEMO_SHOP = "https://www.etsy.com/shop/NorthstarPrintStudio";

export const PAGE_VARIANTS: Record<ExperienceVariant, PageVariant> = {
  meta: {
    id: "meta",
    path: "/",
    documentTitle: "MotionTwist",
    phase: "Meta creative proof of concept",
    heroLineOne: "Create product video ads",
    heroLineTwo: "for free",
    requestInput: DEMO_SHOP,
    loadingCta: "Building creative…",
    motionEyebrow: "Choose your motion",
    motionHeadline: "Same creative. Three perspectives.",
    emptyState: "The demo motion creative will appear here.",
    previewTitle: "Generated Meta motion creative preview",
    draftError: "The motion creative could not be created.",
    footer: "Creates motion creative assets for upload to Meta Ads Manager.",
  },
  etsy: {
    id: "etsy",
    path: "/etsy",
    documentTitle: "MotionTwist",
    phase: "Private proof of concept",
    heroEyebrow: "Turn a storefront into motion",
    heroLineOne: "Your Etsy catalogue,",
    heroLineTwo: "ready to move.",
    heroSupporting: "Preview how a curated Etsy product set becomes a polished 15-second catalogue introduction.",
    requestInput: DEMO_SHOP,
    loadingCta: "Building video…",
    motionEyebrow: "Choose your catalogue motion",
    motionHeadline: "Same products. Three perspectives.",
    emptyState: "The demo shop’s catalogue video will appear here.",
    previewTitle: "Generated Etsy catalogue video preview",
    draftError: "The shop video could not be created.",
    footer: "This application uses mock Etsy data and is not endorsed or certified by Etsy, Inc.",
  },
};

export function resolvePageVariant(pathname: string): PageVariant {
  return pathname.replace(/\/+$/, "") === "/etsy" ? PAGE_VARIANTS.etsy : PAGE_VARIANTS.meta;
}
